<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Test Topic List">
        <div class="text-right">
          <b-button variant="success" href="/#/backend/forms/edit-test-topic">+ Add Test Topic</b-button>
        </div>
        <br />
        <div class="d-flex justify-content-end mb-2">
          <input
            class="form-control"
            type="text"
            placeholder="Search..."
            aria-label="Search"
            style="width: 300px"
          />
        </div>
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Test</b-th>
              <b-th class="text-center">Duration (mins)</b-th>
              <b-th class="text-center">Topic</b-th>
              <b-th class="text-center" style="width: 15%">Status</b-th>
              <b-th class="text-center">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="banner in banners" :key="banner.id">
              <b-td class="text-center">
                {{ banner.id }}
              </b-td>
              <b-td class="text-center">
                {{ banner.test }}
              </b-td>
              <b-td class="text-center">
                {{ banner.duration }}
              </b-td>
              <b-td class="text-center">
                {{ banner.topic }}
              </b-td>
              <b-td class="text-center">
                <b-badge :variant="banner.labelVariant">{{
                  banner.labelText
                }}</b-badge>
              </b-td>
              <b-td class="text-center">
                <b-btn-group>
                  <b-button size="sm" variant="alt-primary" href="/#/backend/forms/edit-test-topic">
                    <i class="fa fa-fw fa-pencil-alt"></i>
                  </b-button>
                  <b-button size="sm" variant="alt-primary" href="">
                    <i class="fa fa-fw fa-times"></i>
                  </b-button>
                </b-btn-group>
              </b-td>   
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [
        {
          id: 1,
          test: "Number Test 1",
          duration: 25,
          topic: "Quantitative ",
          labelVariant: "success",
          labelText: "Active",
        },
        {
          id: 2,
          test: "Number Test 2",
          duration: 30,
          topic: "Quantitative ",
          labelVariant: "danger",
          labelText: "Deactive",
        },
        {
          id: 3,
          test: "Number Test 3",
          duration: 40,
          topic: "Verbal",
          labelVariant: "success",
          labelText: "Active",
        },
        {
          id: 4,
          test: "Number Test 4",
          duration: 45,
          topic: "Reasoning",
          labelVariant: "danger",
          labelText: "Deactive",
        }
      ],
    };
  },
};
</script>
